// removed by extract-text-webpack-plugin
module.exports = {"chartSelector":"chartSelector__2EW-O_NXkykn"};